import { userApi } from "api/user/user";
import { isTokenExpired } from "hooks/useTokenExpired";
import { getToken, removeToken } from "lib/auth";
import { useSnackbar } from "notistack";
import { createContext, useContext, useEffect, useState } from "react";
import { snackBarStyle } from "styles/snackBarStyle";

const UserContext = createContext({
  user: [],
  setUser: () => {},
  logout: () => {},
  setIsAuth_: () => {},
  isAuth: false,
});

const UserProvider = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [user, setUser] = useState([]);
  const [isAuth, setIsAuth] = useState(false);

  const setIsAuth_ = (authStatus) => {
    setIsAuth(authStatus);
  };

  const logout = async () => {
    setIsAuth(false);
    removeToken();
    enqueueSnackbar("logget ud", snackBarStyle());
    await userApi.logout();
  };

  useEffect(() => {
    const token = getToken();
    if (token && token.length > 0) {
      setIsAuth_(!isTokenExpired(token));
    } else {
      setIsAuth_(false);
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        setIsAuth_,
        isAuth,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;

export const useUserContext = () => useContext(UserContext);
